import { useContext, useEffect, useState } from "react";
import { GET_FREE_CLASSIFIED_BY_ID, POST_CLASSIFIED_COMMENT, POST_CLASSIFIED_REPLY, fetchData } from "../../components/Service";
import { useParams } from "../../../node_modules/react-router-dom/dist/index";
import { Context } from "../../components/Context";
import _ from "lodash";
import moment from "../../../node_modules/moment/moment";
import { scrollTop } from "../../components/Helper";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import Share from "../../components/Share";

const RealEstateDetails = () => {
	const { real_estate_id } = useParams();
	const [context] = useContext(Context);
	const [data, setData] = useState();
	const [pageUrl, setPageUrl] = useState();
	const [commentList, setCommentList] = useState();
	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		reset,
	} = useForm({ mode: "onChange" });

	const {
		register: registerReply,
		handleSubmit: handleSubmitReply,
		formState: { errors: errorsReply },
		reset: resetReply,
	} = useForm({ mode: "onChange" });

	const getDetails = (reid) => {
		let payload = {
			id: reid,
			user_id: context?.user?.user_id,
		};

		fetchData(pageUrl?pageUrl:GET_FREE_CLASSIFIED_BY_ID, "POST", payload, false, false, (res) => {
			if (res.status) {
				setData(res?.data);
				setCommentList(res?.data?.comment?.data);
			} else {
				setData();
				setCommentList([]);
			}
		});
	};
	const getDefaultPath = () => {
		if (data) {
			if (data?.cat_id.slug === "jobs") {
				return "/assets/images/business/jobs.jpeg";
			} else if (data?.cat_id.slug === "electronics") {
				return "/assets/images/business/electronics.jpeg";
			} else if (data?.cat_id.slug === "garage-sale") {
				return "/assets/images/business/garage-sale.jpeg";
			} else if (data?.cat_id.slug === "desi-date") {
				return "/assets/images/business/desi-date.jpeg";
			} else if (data?.cat_id.slug === "education-teaching") {
				return "/assets/images/business/education-teaching.jpeg";
			}
			else if (data?.cat_id.slug === "room-mates") {
				return "/assets/images/business/room-mates.jpeg";
			}
			else if (data?.cat_id.slug === "real-estate") {
				return "/assets/images/business/real-estate.jpeg";
			}
		} else {
			return "/assets/images/no-image.jpg";
		}
	};
	const postComment = (data) => {
		let payload = {
			user_id: context?.user?.user_id,
			classified_id: real_estate_id,
			comment: data.description,
		};

		fetchData(POST_CLASSIFIED_COMMENT, "POST", payload, true, false, (res) => {
			if (res.status) {
				reset();
				getDetails(real_estate_id);
			} else {
				toast.error("Unable to post comment.");
			}
		});
	};
	const postReply = (data) => {
		let payload = {
			user_id: context?.user?.user_id,
			classified_id: real_estate_id,
			comment: data.description,
		};
		window.$(`#replyModal`).modal("hide");

		fetchData(POST_CLASSIFIED_REPLY, "POST", payload, true, false, (res) => {
			if (res.status) {
				toast.success(res.message)
				resetReply(); // use the correct reset
				getDetails(real_estate_id);
			} else {
				toast.error("Unable to post reply.");
			}
		});
	};

	useEffect(() => {
		if (real_estate_id && context) {
			getDetails(real_estate_id);
		}
	}, [real_estate_id, context?.user,pageUrl]);


	return (
		<>
			<div class="col-lg-12">
				<div class="card card-forum ">
					<div class="card-header usa-bg px-1">
						<div className="national-bg">
							<div className="row d-flex align-items-center ind1">
								<div className="col-lg-12">
									<h4 class="text-white d-flex mb-0 py-2">{_.startCase(data?.title)}</h4>
								</div>
							</div>
						</div>
					</div>
					<div class="card-body bg-white p-1">
						<div class="card mb-3">
							<div className="card-header p-1">
								<ul className="point-list">
									<li>
										<span>
											<i class="fi fi-sr-eye"></i>
										</span>
										{data?.total_views}
									</li>
									<li>
										<span>
											<i class="fi fi-rr-calendar-lines"></i>
										</span>{" "}
										{data?.created_at ? moment(data?.created_at).format("DD-MMM-YYYY hh:mm a") : ""}
									</li>
									<li>
										<span>
											<i class="fi fi-rs-marker"></i>
										</span>{" "}
										{data?.city_id?.name}
									</li>
								</ul>
							</div>
							<div class="row g-0 align-items-stretch">
								<div class="col-xl-6">
									<img src={data?.image ? data?.image : getDefaultPath()} class="img-fluid rounded-3" />
								</div>
								<div class="col-xl-6">
									<div class="card-body h-100">
										<h6 class="card-title">Contact Person:</h6>
										<div className="table-responsive">
											<table className="table table-borderless table-sm">
												<tr>
													<td className="ps-0">
														<ul className="point-list1">
															<li>
																<span>
																	<i class="fi fi-rr-mobile-button"></i>{" "}
																</span>
															</li>
															<li>
																<spab className="fw-light"> Contact No.</spab>
															</li>
														</ul>
													</td>

													<td>{data?.contact_number}</td>
												</tr>
												<tr>
													<td className="ps-0">
														<ul className="point-list1">
															<li>
																<span>
																	<i class="fi fi-rr-envelope"></i>{" "}
																</span>
															</li>
															<li>
																<spab className="fw-light">Email ID.</spab>
															</li>
														</ul>
													</td>

													<td>{data?.contact_email}</td>
												</tr>
												<tr>
													<td className="ps-0" style={{ width: "140px" }}>
														<ul className="point-list1">
															<li>
																<span>
																	<i class="fi fi-rr-calendar-lines"></i>{" "}
																</span>
															</li>
															<li>
																<spab className="fw-light">Ad Expiry Date</spab>
															</li>
														</ul>
													</td>

													<td>{data?.end_at}</td>
												</tr>
												<tr>
													<td className="ps-0">
														<ul className="point-list1">
															<li>
																<span>
																	<i class="fi fi-rr-tags"></i>{" "}
																</span>
															</li>
															<li>
																<spab className="fw-light">Price </spab>
															</li>
														</ul>
													</td>

													<td className="fw-bold">
														{data?.other_details
															? (() => {
																let otherDetails = JSON.parse(data?.other_details);
																const cur = otherDetails.find((detail) => detail?.Currency);

																const regex = /\((\w{3})\)$/;
																const match = cur?.Currency.match(regex);

																if (match) {
																	return match[1];
																} else {
																	return "USD";
																}
															})()
															: "USD"}{" "}
														{data?.other_details
															? (() => {
																let otherDetailsPP = JSON.parse(data?.other_details);
																const pp = otherDetailsPP.find((detail) => detail?.Property_Price);

																if (pp?.Property_Price) {
																	return parseFloat(pp?.Property_Price).toFixed(2);
																} else {
																	return "0.00";
																}
															})()
															: "0.00"}
													</td>
												</tr>
											</table>
										</div>
									</div>
								</div>
								<div class="col-md-12">
									<div class="card-body h-100">
										<h6>Description</h6>
										<p class="card-text" dangerouslySetInnerHTML={{ __html: data?.message }}></p>
										<Share url={`https://${process.env.REACT_APP_DOMAIN_URL}/real-estate/${data?.id}`}
											id={data?.id}
											type="real-estate"
										/>
									</div>
								</div>
							</div>
						</div>
						{commentList && commentList?.length > 0 && (
							<div className="row">
								<div className="col-md-12">
									<div className="card">
										<div className="card-header">
											<h6>Comments ({data?.comment?.total})</h6>
										</div>
										<div className="card-body">
											<ul className="comments-list">
												{commentList?.map((item) => (
													<li key={item?.id}>
														<span className="img-user">{item?.user?.image ? <img src={item?.user?.image} /> : <img src="/assets/images/slide1-1480.jpg" />}</span>
														<h6>
															{item?.user?.first_name} {item?.user?.last_name}
														</h6>
														<p className="mt-1">{item?.comments}</p>
													</li>
												))}
											</ul>
										</div>
									</div>
								</div>
							</div>
						)}
						{data && data?.comment?.total > 10 && (
								<nav className="pt-3">
									<ul className="pagination justify-content-end">
										<li
											className={`page-item ${data?.comment?.prev_page_url ? "" : "disabled"
												}`}
										>
											<button
												type="button"
												className="page-link"
												onClick={() => setPageUrl(data?.comment?.prev_page_url)}
											>
												<span aria-hidden="true">&laquo;</span> Previous
											</button>
										</li>
										<li
											className={`page-item ${data?.comment?.next_page_url ? "" : "disabled"
												}`}
										>
											<button
												type="button"
												className="page-link"
												onClick={() => setPageUrl(data?.comment?.next_page_url)}
											>
												Next <span aria-hidden="true">&raquo;</span>
											</button>
										</li>
									</ul>
								</nav>
							)}
						<div className="row my-2">
							<div className="col-md-12">
								<div className="card">
									<div className="card-header">
										<h6>Post Comments</h6>
									</div>
									<div className="card-body">
										{context?.userToken ? (
											<div class="mb-3">
												<label for="Respond" class="form-label">
													Respond to Talk
												</label>
												<form onSubmit={handleSubmit(postComment)}>
													<textarea
														class="form-control"
														id="Respond"
														rows="5"
														{...register("description", {
															required: { value: true, message: "Please write some comment." },
														})}
													></textarea>
													<div className="row">
														<div className="col-md-6">{errors.description && <div class="invalid-feedback d-block">{errors.description.message}</div>}</div>
														<div className="col-md-6">
															<div className="d-flex flex-wrap gap-2 justify-content-end mt-2">
																<button
																	class="btn btn-light font13 d-inline-flex align-items-center"
																	onClick={() => reset()}
																	type="button"
																>
																	Cancel
																</button>
																<button
																	class="btn btn-warning font13 d-inline-flex align-items-center"
																	onClick={handleSubmit(postComment)}
																>
																	Post Comment{" "}
																	<i class="fi fi-rr-arrow-small-right ms-2"></i>
																</button>
																{context?.user?.user_id !== data?.user_id && (
																	<button
																		class="btn btn-warning font13 d-inline-flex align-items-center"
																		type="button"
																		data-bs-dismiss="modal"
																		aria-label="Close"
																		onClick={() => {
																			resetReply();
																			window.$(`#replyModal`).modal("show");
																		}}
																	>
																		Reply
																		<i class="fi fi-rr-arrow-small-right ms-2"></i>
																	</button>
																)}
															</div>
														</div>
													</div>
												</form>
											</div>
										) : (
											<div class="text-center text-danger">Please <a href="#!" className=" fw-bold" data-bs-toggle="modal" data-bs-target="#loginModal">
												Login
											</a> to post comment.</div>
										)}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				className="modal fade pe-0"
				id={`replyModal`}
				data-bs-backdrop="static"
				data-bs-keyboard="false"
				tabindex="-1"
				aria-labelledby="staticBackdropLabel"
				aria-hidden="true"
			>
				<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
					<div className="modal-content apply-job-form">
						{/* <button className="btn-close" type="button" data-bs-dismiss="modal" aria-label="Close"></button> */}
						<button
							className="btn-close"
							type="button"
							data-bs-dismiss="modal"
							aria-label="Close"
							onClick={() => resetReply()}
						/>
						<div className="modal-header d-block text-center border-bottom-0">
							<h5 className="text-brand-1 text-capitalize">Reply this ad  </h5>
						</div>
						<div className="modal-body px-4 pb-4">
							<form onSubmit={handleSubmitReply(postReply)}>
								<textarea
									class="form-control"
									id="RespondReply"
									rows="5"
									{...registerReply("description", {
										required: {
											value: true,
											message: "Please write some reply.",
										},
									})}
								/>
								{errorsReply.description && (
									<div class="invalid-feedback d-block text-danger text-start">
										{errorsReply.description.message}
									</div>
								)}
								<div className="d-block text-center mt-2 mb-3">
									<button className="btn btn-default hover-up m-auto" type="submit">
										Submit Reply
									</button>
								</div>
							</form>

						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default RealEstateDetails;
